"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUB_AD_HUB_BRAND_ID_TO_ENCYP_VALUE = exports.PubAdHubBrandId = exports.PubAdHubCampaignId = exports.PubAdHubPublisherId = void 0;
var PubAdHubPublisherId;
(function (PubAdHubPublisherId) {
    PubAdHubPublisherId[PubAdHubPublisherId["Aven"] = 5] = "Aven";
})(PubAdHubPublisherId || (exports.PubAdHubPublisherId = PubAdHubPublisherId = {}));
var PubAdHubCampaignId;
(function (PubAdHubCampaignId) {
    PubAdHubCampaignId[PubAdHubCampaignId["Walmart"] = 2] = "Walmart";
    PubAdHubCampaignId[PubAdHubCampaignId["Amazon"] = 4] = "Amazon";
})(PubAdHubCampaignId || (exports.PubAdHubCampaignId = PubAdHubCampaignId = {}));
var PubAdHubBrandId;
(function (PubAdHubBrandId) {
    PubAdHubBrandId[PubAdHubBrandId["Walmart"] = 2] = "Walmart";
    PubAdHubBrandId[PubAdHubBrandId["Amazon"] = 4] = "Amazon";
})(PubAdHubBrandId || (exports.PubAdHubBrandId = PubAdHubBrandId = {}));
/**
 * PubAdHub uses a url param called "encyp" that is unique to each brand and whether or not a deeplink is used.
 * This is given to us by a sheet that can be found here:
 * https://docs.google.com/spreadsheets/d/1mI5fcGI-oWk-HiKfJnztxcr7p-iy1oxL/edit?gid=1101170552#gid=1101170552
 */
exports.PUB_AD_HUB_BRAND_ID_TO_ENCYP_VALUE = {
    [PubAdHubBrandId.Amazon]: {
        withDeeplink: 'ht2VNN0AbHn2qmEG73ZolHlm4lAw5d2y9Cje4ILvvjUrixHqkCBBmY1WvlrTyJX1',
        withoutDeeplink: 'ht2VNN0AbHn2qmEG73ZolHlm4lAw5d2y9Cje4ILvvjV+4iJHezfT37H5VCDXDLH7',
    },
    [PubAdHubBrandId.Walmart]: {
        withDeeplink: 'ht2VNN0AbHn2qmEG73ZolCWlWvb+VstQtETKsTOtBPG8TC2grJ4uSVMiCgs7vl08',
        withoutDeeplink: 'ht2VNN0AbHn2qmEG73ZolCWlWvb+VstQtETKsTOtBPEyG+O/sW9wB5tdxXXz5ExB',
    },
};
